import { render } from "./LegalStuff.vue?vue&type=template&id=38078dcd&scoped=true"
import script from "./LegalStuff.vue?vue&type=script&lang=js"
export * from "./LegalStuff.vue?vue&type=script&lang=js"

import "./LegalStuff.vue?vue&type=style&index=0&id=38078dcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38078dcd"]])

export default __exports__